import { Translation } from './translation';

export const fr_residia: Translation = {
  common: {
    apply: 'Appliquer',
    type: 'Type',
    showLess: 'Voir moins',
    showMore: 'Voir plus',
    map: 'Carte',
    list: 'Liste',
    results: '{count} résultats',
    continue: 'Poursuivre',
    back: 'Retourner',
    currency: {
      short: 'CHF',
      price: `CHF {price}.–`,
      pricePerMonth: `CHF {price}.– / mois`,
      pricePerSquareMeter: `CHF {price}.–/m<sup>2</sup>`,
    },
    details: "Details",
  },
  mapPrivacy: {
    text: `
      Pour pouvoir afficher la carte du fournisseur tiers Google Maps,
      nous avons besoin de votre accord pour l'utilisation de cookies.
    `,
    button: `Gérer les cookies`,
  },
  filters: {
    common: {
      reset: 'Réinitialiser',
      resetAll: 'Réinitialiser tout',
      deleteAll: 'Supprimer tout',
      filter: 'Filtre',
      additionalFilters: 'Filtres supplémentaires',
      showResults: 'Afficher les résultats',
      showXResults: 'Afficher {count} résultats',
      modifySearch: 'Modifier la recherche',
      in: 'à',
      title_rent: {
        none: 'Louer un bien immobilier',
        house: 'Maisons à louer',
        flat: 'Appartements à louer',
        commercial: 'Objets commerciaux à louer',
      },
      title_buy: {
        none: 'Acheter un bien immobilier',
        house: 'Maisons à vendre',
        flat: 'Appartements à vendre',
        land: 'Terrains à vendre',
        income: 'Immeubles de rendement à vendre',
        commercial: 'Objets commerciaux à vendre',
      },
    },
    search: {
      label: 'Canton, lieu, code postal, référence du bien, ...',
      noResults: "Aucun résultat, veuillez vérifier l'orthographe.",
    },
    contractType: {
      buy: 'Acheter',
      rent: 'Louer',
    },
    category: {
      main: {
        label: 'Catégorie',
        all: 'Tous',
        house: 'Maison',
        apartment: 'Appartement',
        estate: 'Terrain',
        incomeProperty: 'Immeuble de rendement',
        commercial: 'Commerce',
      },
      sub: {
        businessHouse: 'Immeuble commercial',
        garageParking: 'Parking/garage',
        commercialResidentialBuilding: 'Immeuble mixte',
        office: 'Bureau',
        shop: 'Commerce',
        warehouse: 'Dépôt',
        factory: 'Usine',
        hotel: 'Hôtel',
        restaurant: 'Restaurant',
        practice: 'Cabinet',
        multiFamilyHouse: "Immeuble d'habitation",
        buildingLand: 'Terrain à bâtir',
        agriculturalLand: 'Terrain agricole',
        industrialLand: 'Terrain industriel',
        atticFlat: 'Appartement en attique',
        roofFlat: 'Appartement sous les toits',
        maisonette: 'Duplex',
        studio: 'Studio',
        terraceFlat: 'Appartement avec terrasse',
        loft: 'Loft',
        gardenFlat: 'Appartement en rez-de-chaussée',
        floorFlat: 'Appartement',
        holidayFlat: 'Appartement de vacances',
        furnishedFlat: 'Appartement meublé',
        oneFamilyHouse: 'Maison individuelle',
        midTerraceHouse: 'Maison mitoyenne',
        endTerraceHouse: "Maison mitoyenne d'angle",
        rustico: 'Rustico',
        semidetachedHouse: 'Maison jumelle',
        terraceHouse: 'Maison en terrasse',
        farmhouse: 'Ferme',
        mansion: 'Villa',
        holidayHouse: 'Maison de vacances',
        countryHouse: 'Maison de campagne',
        twoFamilyHouse: 'Maison bifamiliale',
        chalet: 'Chalet',
      },
    },
    price: {
      label: 'Prix',
    },
    roomCount: {
      label: 'Pièces',
      to: 'à',
    },
    livingSpace: {
      label: `Surface d'habitation`,
    },
    propertySpace: {
      label: 'Superficie du terrain',
    },
    usageSpace: {
      label: 'Surface utilisable',
    },
    sort: {
      label: 'Tri',
      newest: 'Derniers biens immobiliers',
      lowestPrice: 'Prix (croissant)',
      highestPrice: 'Prix (décroissant)',
    },
    rateOfReturn: {
      label: 'rendement brut',
    },
    units: {
      label: 'unités',
    },
  },
  regionSearch: {
    city: 'Ville',
    village: 'Lieu',
    county: 'Arrondissement',
    suburb: 'Quartier',
    state: 'Canton',
  },
  noResults: {
    title: 'Aucun résultat',
    text: `
      Sauvegarder votre recherche et être informé lorsque de nouveaux biens correspondent à vos critères.
    `,
  },
  searchSubscription: {
    setup: 'Créer un abonnement de recherche',
    save: 'S’abonner à la recherche',
    overlay: {
      title: 'Abonnement de recherche',
      text: `
        Nous nous ferons un plaisir de vous
        informer par courriel dès qu’un bien
        correspondant à vos critères sera disponible.
      `,
      showResults: 'Afficher les résultats de la recherche',
      changeFilter: {
        desktop: {
          part1: 'Vous pouvez modifier vos critères dans les',
          button: 'filtres',
          part2: ' ',
        },
        mobile: {
          button: 'Modifier critères de recherche',
        },
      },
    },
    stepper_title: {
      desktop: {
        step1: 'Définir les critères de recherche',
        step2: 'Définir les critères de recherche',
        step3: "Finaliser l'abonnement de recherche",
        step_final: 'Abonnement de recherche enregistré',
      },
      mobile: {
        step1: 'Définir les critères de recherche',
        step2: "Finaliser l'abonnement de recherche",
        step_final: 'Abonnement de recherche enregistré',
      },
    },
    search: {
      label: 'Canton, lieu, code postal, ...',
    },
    location: 'Lieu',
    andRadius: 'et rayon',
    yourDetails: 'Vos données',
    yourSearchCriteria: 'Vos critères de recherche',
    toObjectSearch: 'Vers la recherche de biens',
    cookieMessage: {
      description: `
        Afin d'afficher le formulaire de contact, veuillez accepter les cookies pour une publicité ciblée.
      `,
      button: `Gérer les cookies`,
    },
    form: {
      firstName: 'Prénom',
      firstNameRequired: 'L’indication du prénom est obligatoire.',
      lastName: 'Nom de famille',
      lastNameRequired: 'L’indication du nom de famille est obligatoire.',
      email: 'E-mail',
      emailRequired: "L’indication d'un e-mail est obligatoire.",
      receiveNewsletter: "S'inscrire à la newsletter Residia",
      newsletterHint: 'Vous pouvez à tout moment vous désinscrire.',
      acceptPrivacyHint: `Par la présente, vous acceptez les <a target="_blank" href="/fr/cgv/">conditions générales</a> et la <a target="_blank" href="/fr/protection-donnees/">politique de confidentialité</a> de Residia.`,
      thirdPartyHint: `
        Vos données ne seront pas transmises à un tiers.
        Vous trouverez ici notre <a target="_blank" href="/fr/protection-donnees/">politique de confidentialité</a>.<br>
        Ce site est protégé par
        <a target="_blank" href="https://www.google.com/recaptcha/about/">reCAPTCHA</a> et la
        <a target="_blank" href="https://policies.google.com/privacy">politique de confidentialité de Google</a>
        et ses conditions générales de service s’appliquent.
      `,
    },
    successMessage: {
      title: 'Abonnement de recherche créé.',
      paragraph1: `
      Vous recevrez bientôt un courriel contenant un lien de confirmation.
      `,
      paragraph2: `
      Dès que vous aurez confirmé votre inscription, vous recevrez régulièrement des courriels contenant des offres de biens correspondant à vos critères.
      `,
    },
  },
  similarObjects: {
    title: 'Biens similaires à proximité',
    xResults: '{count} résultats',
    modifySearch: {
      text: `
        Modifiez la recherche <br>
        pour afficher plus de résultats.
      `,
      button: 'Adapter la recherche',
    },
  },
  realEstateObject: {
    sold: 'Vendu',
    priceOnRequest: 'Prix sur demande',
    reserved: 'Réservé',
    topOffer: 'Top objet',
    virtualTour: 'Visite virtuelle',
  },
  agentOverview: {
    agents: 'Courtier-ères',
    director: 'Direction',
    location: 'Site',
    agentImagePlaceholderAlt: 'Espace réservé pour l\'image de l\'agent immobilier',
    region: "Région",
    properties: "Biens",
    regions: {
      ch: {
        zh: 'Zurich',
        fr: 'Fribourg',
        vd: 'Vaud',
        ge: 'Genève',
        ne: 'Neuchâtel',
        ju: 'Jura',
        be: 'Berne',
        vs: 'Valais',
        ti: 'Tessin',
        ur: 'Uri',
        ow: 'Obwald',
        nw: 'Nidwald',
        lu: 'Lucerne',
        bl: 'Bâle Campagne',
        bs: 'Bâle Ville',
        so: 'Soleure',
        ag: 'Argovie',
        zg: 'Zoug',
        gl: 'Glaris',
        gr: 'Grisons',
        sz: 'Schwyz',
        sh: 'Shaffhouse',
        tg: 'Thurgovie',
        sg: 'Saint-Gall',
        ar: 'Appenzell Rhodes-Intérieures',
        ai: 'Appenzell Rhodes-Extérieures',
      },
    }
  }
};
